// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"DefaultLayout_breadcrumbs__2C65k"};